
import SubjectPage from '../subjects/SubjectPage';



function ChapterWiseWeightage() {


  
  // Define the main heading text once for consistency
  const pageTitleText = "JEE Chapter Wise Weightage ";


  return (
    <>
       

      <SubjectPage 
        name={pageTitleText} 
        link="chapter-wise-weightage" 
        type="chapterwiseweightage"
      />

      
    </>
  );
}

export default ChapterWiseWeightage;